<div style="display: flex;margin-left: -13px;margin-top: -20px;">
  <div style="margin-right: 30px;">
    <div>
      <mat-slide-toggle color="primary" labelPosition="before" [(ngModel)]="viewModel.removeDuplicateRow">Remove duplicate rows</mat-slide-toggle>
    </div>
  </div>

  <div style="margin-right: 10px;">
    <div>
      <mat-form-field style="width: 200px;margin-top: -20px;margin-left: -40px;">
        <mat-label>Which row to keep?</mat-label>
        <mat-select [(ngModel)]="viewModel.whichRowKeep">
          <mat-option *ngFor="let type of WhichRowKeepTypes" [value]="type">
              {{WhichRowKeepUtil.toString(type)}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>  
</div>